// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1brv7","overlay":"Modal_overlay__16pLf","load":"Modal_load__3Cjjq"};